export type UrlClipSelectionTab = "ailink" | "sentinel" | "smtp" | "frontel";

interface UrlClipSelectionArgs {
  tab: UrlClipSelectionTab;
  targetId: string;
  clipsData: any[];
  sentinelData: any[];
  smtpData: any[];
  frontelData: any[];
  fetchingFilteredData: boolean;
  fetchingFilteredDataSentinel: boolean;
  fetchingFilteredDataSMTP: boolean;
  fetchingFilteredDataFrontel: boolean;
  filtersApplied: boolean;
  filtersAppliedSMTP: boolean;
  filtersAppliedFrontel: boolean;
}

export const getUrlClipSelectionOutcome = ({
  tab,
  targetId,
  clipsData,
  sentinelData,
  smtpData,
  frontelData,
  fetchingFilteredData,
  fetchingFilteredDataSentinel,
  fetchingFilteredDataSMTP,
  fetchingFilteredDataFrontel,
  filtersApplied,
  filtersAppliedSMTP,
  filtersAppliedFrontel,
}: UrlClipSelectionArgs): { status: "skip" | "not_found" | "found"; row: any | null } => {
  if (tab === "ailink") {
    if (fetchingFilteredData || !filtersApplied || clipsData.length === 0) {
      return { status: "skip", row: null };
    }
    const row = clipsData.find((item: any) => item.file_id === targetId) ?? null;
    return row ? { status: "found", row } : { status: "not_found", row: null };
  }

  if (tab === "sentinel") {
    if (
      fetchingFilteredDataSentinel ||
      !filtersApplied ||
      sentinelData.length === 0
    ) {
      return { status: "skip", row: null };
    }
    const row =
      sentinelData.find((item: any) => item.file_id === targetId) ?? null;
    return row ? { status: "found", row } : { status: "not_found", row: null };
  }

  if (tab === "smtp") {
    if (fetchingFilteredDataSMTP || !filtersAppliedSMTP || smtpData.length === 0) {
      return { status: "skip", row: null };
    }
    const row = smtpData.find((item: any) => item.clip_id === targetId) ?? null;
    return row ? { status: "found", row } : { status: "not_found", row: null };
  }

  if (
    fetchingFilteredDataFrontel ||
    !filtersAppliedFrontel ||
    frontelData.length === 0
  ) {
    return { status: "skip", row: null };
  }
  const row = frontelData.find((item: any) => item.file_id === targetId) ?? null;
  return row ? { status: "found", row } : { status: "not_found", row: null };
};
